import useSWRFetcher, { SWRFetchError } from "../commonly-stored/fetcher";
import { useCallback } from "react";
import useSWR from "swr";
import settings from "../../../constants/settings";
import { InventoryResponse } from "../../../reducers/componentSearch";

export default function usePartInventory(partId: string) {
  const fetcher = useSWRFetcher<InventoryResponse>();

  const {
    data: inventoryResponse,
    mutate,
    error,
  } = useSWR<InventoryResponse, SWRFetchError>(
    `${settings.api_url}/parts/${partId}/inventory`,
    fetcher,
  );

  const refreshInventoryResponse = useCallback(() => {
    void mutate();
  }, [mutate]);

  return {
    inventoryResponse: inventoryResponse,
    refreshInventoryResponse,
    errored: error !== undefined,
  };
}
